import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAddress,
  setProviderType,
  resetSearchParams,
  setFilterChangeStatus,
  resetSortingChangeStatus,
  setSearchProviderParams,
  setShowAllFiltersPanel,
  setShowCostClickCount,
  resetShowCostClickCount,
  resetShowCostClickTimestamp,
} from '../../../../redux/admin/priceCompareSlice';
import DoctorSearchResults from '../find-doctor/search-results';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import './SearchResults.scss';
import PriceCompareSearch from '../PriceCompareSearch';
import backBtn from '../../../img/pricecompare/back-btn.svg';
import SearchPageSkeleton from '../skeleton/SearchPageSkeleton';
import {
  getDoctorDetails,
  getPriceComaperFilters,
  searchProviders,
} from 'src/redux/admin/api-calls/priceCompare';
import { CLIENT_TYPES } from 'src/constants';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchResults = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { searchParamsForUI } = useSelector(
    (state) => state?.priceCompareAdmin,
  );
  const {
    Display_Network_For_PriceComparison_Admin,
    Value_Network_For_PriceComparison_Admin,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const {
    address,
    providerType,
    searchResults,
    isSearchingProviders,
    searchProviderParams,
  } = useSelector((state) => state?.priceCompareAdmin);
  const [isProvidersActive, setProvidersActive] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [modifySearch, setModifySearch] = useState(false);
  const [modify, setModify] = useState(false);
  const [isEditingSearch, setIsEditingSearch] = useState(false);
  const searchProviderFiltersChanged = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderFiltersChanged,
  );
  const searchProvidersSortingChanged = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProvidersSortingChanged,
  );
  const { sortby, sortdirection } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderParams,
  );
  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });

  useEffect(() => {
    dispatch(resetShowCostClickCount());
    dispatch(resetShowCostClickTimestamp());
  }, []);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    if (searchProviderFiltersChanged === true) {
      dispatch(setFilterChangeStatus(false));
      dispatch(searchProviders());
      dispatch(getPriceComaperFilters());
    }
  }, [searchProviderFiltersChanged]);

  useEffect(() => {
    if (searchProvidersSortingChanged === true) {
      dispatch(resetSortingChangeStatus());
      dispatch(searchProviders());
    }
  }, [searchProvidersSortingChanged]);

  useEffect(() => {
    dispatch(searchProviders());
    setModify(false);
  }, [searchParamsForUI]);

  useEffect(() => {
    if (location.state === undefined || !address) {
      navigate('/admin/price-compare');
    }
    dispatch(searchProviders());
  }, []);

  const searchInitiationHandler = () => {
    setShowSearchResults(true);
    setModifySearch(true);
    setIsEditingSearch(true);
  };

  const pageInfo = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const modifySearchHandler = () => {
    setModifySearch(false);
    searchInitiationHandler();
    dispatch(setSearchProviderParams({ pagenumber: 1 }));
    //dispatch(searchProviderFiltersInitial()); // #resolution 1 to reset filter on modify
  };

  const getSearchInformation = () => {
    let searchInfo = '';
    if (providerType === 'doctors') {
      searchInfo =
        searchProviderParams.DoctorByName != null
          ? ' / ' + searchProviderParams.DoctorByName
          : ' / ' + searchProviderParams.DoctorByType[0];
    } else {
      searchInfo =
        searchProviderParams.FacilityByName != null
          ? ' / ' + searchProviderParams.FacilityByName
          : ' / ' + searchProviderParams.FacilityByType[0];
    }
    return searchInfo;
  };
  const goBack = () => {
    navigate('/admin/price-compare');
  };
  return (
    <div className="price-compare-result-admin-container">
      <span
        className="sr-only"
        role="heading"
        aria-level={1}
        tabIndex={0}
        ref={pageInfo}
      >
        {t('member.price_comparison.accessibility_page_info')}
      </span>
      {!modify ? (
        <div className="container-offset">
          {isSearchingProviders ? (
            <SearchPageSkeleton />
          ) : (
            <>
              <div>
                <div className="header-container">
                  <div className="d-flex align-items-center">
                    <span className="pt-3 mr-3">
                      <img
                        className="back-btn-to-serach-page"
                        src={backBtn}
                        role="button"
                        alt="Click to Go Back"
                        onClick={() => goBack()}
                      />
                    </span>
                    <h1 className="content-header" aria-hidden={true}>
                      {t('member.price_comparison.heading_text_compare')}{' '}
                      <span className="content-header-bold">
                        {t('member.price_comparison.heading_text_price')}
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
              <div className="find-provider-container">
                <div className="price-compare-sub-text-on-main">
                  {t('admin.pages.price_comparison.page_sub_heading')}{' '}
                  <a className="learn-more">
                    {t('member.price_comparison.learn_more')}
                  </a>
                </div>
                <div>
                  <div>
                    <div>
                      <div className="main-wrapper d-flex justify-content-between mt-3">
                        <div className="top">
                          <div className="top-container">
                            <div>
                              <div className="service-provider">
                                <div className="text-container">
                                  {t(
                                    'member.price_comparison.procedure_container.container_text',
                                  )}
                                </div>
                                <div className="flex-container">
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      {t(
                                        'member.price_comparison.procedure_container.service_for_label',
                                      )}
                                    </span>
                                    {location.state?.procedureForData?.label}
                                    <span className="pipe">&nbsp;|&nbsp;</span>
                                  </div>
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      {t(
                                        'member.price_comparison.procedure_container.health_procedure_label',
                                      )}
                                    </span>
                                    {location.state?.helthProcedureData?.label}
                                    {location.state?.billedamount == '' ||
                                    location.state?.billedamount === '0.00' ? (
                                      ''
                                    ) : (
                                      <span className="pipe">
                                        &nbsp;|&nbsp;
                                      </span>
                                    )}
                                  </div>
                                  {location.state?.billedamount == '' ||
                                  location.state?.billedamount === '0.00' ? (
                                    ''
                                  ) : (
                                    <div className="search-result-data">
                                      <span className="search-result-data-heading">
                                        {t(
                                          'member.price_comparison.procedure_container.billed_amount',
                                        )}
                                      </span>
                                      {`$${location.state?.billedamount}`}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="service-provider">
                                <div className="text-container">
                                  {t(
                                    'member.price_comparison.provider_container.container_text',
                                  )}
                                </div>
                                <div className="flex-container">
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      {t(
                                        'member.price_comparison.provider_container.location_label',
                                      )}
                                    </span>
                                    {location.state?.locationData}
                                  </div>
                                  <div className="search-result-data">
                                    <span className="pipe">&nbsp;|&nbsp;</span>
                                    <span className="search-result-data-heading">
                                      {Display_Network_For_PriceComparison_Admin &&
                                      Value_Network_For_PriceComparison_Admin ===
                                        'tier'
                                        ? t(
                                            'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                          ) + ' : '
                                        : t(
                                            'member.price_comparison.provider_container.networks_dropdown_label',
                                          ) + ' : '}
                                    </span>
                                    {searchParamsForUI?.networksData?.label ||
                                      'All Plan Networks'}
                                    {searchParamsForUI?.typesOfSpecialtyData
                                      ?.label && (
                                      <span className="pipe">
                                        &nbsp;|&nbsp;
                                      </span>
                                    )}
                                  </div>
                                  {searchParamsForUI?.typesOfSpecialtyData
                                    ?.label && (
                                    <div className="search-result-data">
                                      <span className="search-result-data-heading">
                                        {location.state?.providerByData ===
                                        'doctor-name'
                                          ? t(
                                              'member.price_comparison.provider_container.by_doctor_name',
                                            )
                                          : location.state?.providerByData ===
                                            'doctor-type'
                                          ? t(
                                              'member.price_comparison.provider_container.by_doctor_specialty',
                                            )
                                          : location.state?.providerByData ===
                                            'facility-type'
                                          ? ' Facility Type'
                                          : ' Facility Name or Tax ID'}{' '}
                                        :{' '}
                                      </span>
                                      {
                                        location.state?.typesOfSpecialtyData
                                          ?.label
                                      }
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="button-container">
                          <div className="modify-btn-container">
                            <GenericButton
                              className="modify-filter-btn"
                              variant="secondary"
                              onClick={() => {
                                setModify(!modify);
                              }}
                            >
                              {t('member.price_comparison.modify_btn_label')}
                            </GenericButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="container-offset">
          <PriceCompareSearch label="modify search" />
        </div>
      )}
      <DoctorSearchResults
        data={searchResults.data}
        pagination={searchResults.pagination}
        isSearchingProviders={isSearchingProviders}
        serachNetworksFor={
          searchParamsForUI?.networksData || {
            label: 'All Plan Networks',
            value: 'all-plan-networks',
          }
        }
        CoveredCostComparePriceArray={location.state}
      />
    </div>
  );
};

export default SearchResults;
